import utils from '../utils/index';
function isEffectiveValue(value) {
    return value !== undefined && value !== '';
}
function canCloneString(value) {
    const strArr = ['options', 'config', 'mini_url', 'version', 'successUrl', 'failUrl', 'jumpType'];
    return strArr.includes(value);
}
function baseFormatParams(result, object, source, key, isFirst) {
    const objValue = object[key];
    const srcValue = source[key];
    // config,options 可以直接传JSON.stringify格式的数据
    if (isFirst && objValue && srcValue && utils.isStr(srcValue) && canCloneString(key)) {
        result[key] = srcValue;
    }
    else if (utils.isArray(objValue)) {
        result[key] = [];
        objValue.forEach((_, index) => {
            baseFormatParams(result[key], objValue, srcValue || objValue, index, false);
        });
    }
    else if (utils.isObj(objValue)) {
        result[key] = {};
        for (const newKey in objValue) {
            baseFormatParams(result[key], objValue, srcValue || objValue, newKey, false);
        }
    }
    else if (isEffectiveValue(objValue) || isEffectiveValue(srcValue)) {
        const value = srcValue || objValue;
        if (isEffectiveValue(value)) {
            result[key] = value;
        }
    }
}
function payFormatParams(object, source) {
    const result = {};
    const keys = Object.keys(object);
    keys.forEach(key => {
        baseFormatParams(result, object, source, key, true);
    });
    return result;
}
export { payFormatParams };
